import axios from "axios";

const GetTelephoneCard = async () => {
  return Promise.resolve({ data: { StatusCode: 200, ResultSet: [] } });
};

export default {
  GetTelephoneCard,
};
